<template>
  <div id="app">
    <transition name="zoom" mode="out-in">
      <component :is="layout">
        <router-view />
      </component>
    </transition>
  </div>
</template>

<script>
import Vue from 'vue';
import store from "@/store";
import MainLayout from "@/layouts/MainLayout.vue";
import BotLayout from "@/layouts/BotLayout.vue";
import Axios from 'axios'
import { Service } from 'axios-middleware';

export default {
  computed: {
    layout() {
      return (this.$route.meta.layout || "main") + "-layout";
    }
  },
  mounted () {
    const service = new Service(Axios);

    service.register({
      onResponse(response) {
        store.dispatch('setAuthStatus', true);
        return response;
      },
      onResponseError(error) {
        if (error.response.status === 401) {
          if (store.getters.getAuthStatus) {
            store.dispatch('setAuthPopupStatus', true)
          } else {
            const data = JSON.parse(error.response.data);
            if (data.qcrm_url) {
              Vue.prototype.qcrm_url = data.qcrm_url;
              window.location.assign(`${data.qcrm_url}/?qbotbuildersingon=true`);
            } else {
              console.error('Unauthorized, but not QCRM link given', error);
            }
          }
        } else {
          console.error(error);
        }
        return error;
      }
    });

  },
  methods: {
  },
  components: {
    MainLayout,
    BotLayout
  }
};
</script>

<style lang="scss">
* {
  box-sizing: border-box;
  font-family: "Helvetica Neue", Helvetica, sans-serif;
}
body {
  margin: 0;
  color: #a1a1a1;
}
input,
textarea,
button {
  outline: none;
}
.icon {
  cursor: pointer;
}

#app {
  background-color: #131415;
}

select {
  -webkit-appearance: none;
}

// animation

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.fade-fast-enter-active,
.fade-fast-leave-active {
  transition: opacity 0.2s cubic-bezier(0.25, 0.8, 0.25, 1);
}
.fade-fast-enter, .fade-fast-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.zoom-enter-active,
.zoom-leave-active {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-name: zoom;
}

.zoom-leave-active {
  animation-direction: reverse;
}

@keyframes zoom {
  from {
    opacity: 0;
    transform: scale3d(0.9, 0.9, 0.5);
  }

  100% {
    opacity: 1;
  }
}
</style>
